// extracted by mini-css-extract-plugin
export var deleteModal = "_hm-0";